import { EmptyState } from 'ui/emptyState';
import { ErrorStatePageError } from 'ui/illustrations';
import {
  IntelligentInsightsBackground,
  Wrapper,
  DescriptionWrapper,
} from 'modules/intelligentInsights/IntelligentInsights.styles';
import { Link } from 'ui/links';

export const IntelligentInsightsError = ({ testId }: { testId: string }) => (
  <IntelligentInsightsBackground data-test={testId}>
    <Wrapper>
      <EmptyState
        Illustration={ErrorStatePageError}
        title="Oops!"
        subtitle={
          <DescriptionWrapper>
            {`We had a problem fetching this page. `}
            <Link size="body1" href="/intelligentInsights/sendTimeOptimizationInsights">
              Click here
            </Link>
            {` to go back and try again.`}
          </DescriptionWrapper>
        }
      />
    </Wrapper>
  </IntelligentInsightsBackground>
);
